import React from 'react'
import SectionWhoWeAre from './sectionWhoWeAre'
import "./whoWeAre.scss";

function WhoWeAre() {
  return (
    <div className='container-who-we-are'>
        <div className='section-who-we-are'>
            <SectionWhoWeAre />
        </div>
    </div>
  )
}

export default WhoWeAre